import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { CommercialCalculator } from '../Calculators'

import { unitedNumber } from '../propTypes'
import * as info from './info'

import UnitToggle from '../Widgets/UnitToggle'
import CalculationGroup from '../Widgets/CalculationGroup'

export default class GrossDevelopmentValueForm extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(CommercialCalculator).isRequired,
    data: PropTypes.shape({
      totalLandArea: PropTypes.number,
      rentValue: PropTypes.number,
      initialYield: PropTypes.number,
      purchasersCosts: unitedNumber,
    }).isRequired,
    readOnly: PropTypes.bool,
    updateField: PropTypes.func,
    updateUnit: PropTypes.func,
  }

  handleFieldChangedFactory = (field) => (value) => this.props.updateField(field, value)

  render() {
    const { calculator, data, readOnly, updateUnit } = this.props

    return (
      <Fragment>
        <h2>Gross Development Value</h2>

        {! readOnly && <UnitToggle onChange={updateUnit} value={data.unit} />}

        <CalculationGroup
          readOnly={readOnly}
          field='totalLandArea'
          info={info.totalLandArea}
          label='Total area'
          value={data.totalLandArea}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('totalLandArea')}
          input={{ suffix: calculator.getUnitAreaLabel() }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='netLandArea'
          info={info.netLandArea}
          label='Developable land'
          value={data.netLandArea}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('netLandArea')}
          input={{ suffix: calculator.getUnitAreaLabel(true) }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='rentValue'
          info={info.rentValue}
          label='Rent value'
          value={data.rentValue}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('rentValue')}
          total={calculator.getPassingRent()}
          totalLabel='Passing rent'
          input={{
            prefix: '£',
            suffix: calculator.getPerUnitAreaLabel()
          }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='initialYield'
          info={info.initialYield}
          label='Initial yield'
          value={data.initialYield}
          unit={data.unit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('initialYield')}
          average={calculator.getAverage(calculator.getGrossDevelopmentValue())}
          averageLabel={`GDV per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getGrossDevelopmentValue()}
          totalLabel='Gross Development Value'
          input={{ suffix: '%' }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='purchasersCosts'
          info={info.purchasersCosts}
          label='Puchasers costs'
          value={data.purchasersCosts.value}
          unit={data.purchasersCosts.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('purchasersCosts')}
          average={calculator.getAverage(calculator.getNetDevelopmentValue())}
          averageLabel={`NDV per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getNetDevelopmentValue()}
          totalLabel='Net Development Value'
          input={{ allowZero: true }}
        />
      </Fragment>
    )
  }
}
